import { BaseURL } from '../../config/axios';

export default function DropZone({ setData, label, name, images, errors = {}, touch = {}, withSizeValidation = false }) {
    const hasError = (touch[name] && errors[name]) ? true : false

    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const files = event.dataTransfer.files;
        if (files && files[0]) {
            const file = files[0];
            const totalSizeInKB = file.size / (1024);
            if (withSizeValidation && totalSizeInKB > 800) {
                alert('حجم عکس انتخابی بیشتر از حداکثر مجاز است.')
                return
            }
            setData(prev => {
                return {
                    ...prev,
                    [name]: [file]
                }
            })
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const handleFileSelect = (event) => {
        const files = event.target.files;
        if (files && files[0]) {
            const file = files[0];
            const totalSizeInKB = file.size / (1024);
            if (withSizeValidation && totalSizeInKB > 800) {
                alert('حجم عکس انتخابی بیشتر از حداکثر مجاز است.')
                return
            }
            setData(prev => {
                return {
                    ...prev,
                    [name]: [file]
                }
            })
        }
    };

    return (
        <div className='flex flex-col items-start'>
            <label className={`mr-3 mb-3 text-sm ${hasError ? 'text-red-500' : ''}`}>{label}</label>
            <div
                className={`flex flex-col items-center text-center justify-center w-full h-64 p-4 border-2 border-dashed ${hasError ? 'border-red-500' : 'border-gray-300'} rounded-lg cursor-pointer`}
                onDrop={handleDrop}
                onDragOver={handleDragOver}>
                <input
                    type="file"
                    className="hidden"
                    onChange={handleFileSelect}
                    id={name} accept='image/jpeg, image/jpg, image/png, image/webp'
                />
                {withSizeValidation && <p className='text-sm text-red-500'>حداکثر حجم مجاز آپلود 800 کیلوبایت است</p>}
                <label htmlFor={name} className="cursor-pointer mb-2">
                    <p className="text-gray-500">
                        عکس را داخل بیاندازید؛ یا با کلیک عکس مورد نظر را انتخاب کنید
                    </p>
                </label>
                <div className='flex gap-3'>
                    {(!!images[0] && images[0].path) ? (
                        <div className="relative">
                            <img
                                src={BaseURL + images[0]?.path}
                                alt="Preview"
                                className="object-cover w-64 h-52 rounded-lg"
                            />
                            <span className='absolute top-1/2 -translate-x-1/2 -translate-y-1/2 p-2 rounded bg-white left-1/2'>قبلی</span>
                        </div>
                    ) : (!!images.length) && <div>
                        <img
                            src={URL.createObjectURL(images[0])}
                            alt="Preview"
                            className="object-cover w-64 h-52 rounded-lg"
                        />
                    </div>}
                </div>
            </div>
            {hasError && <p className="absolute right-2 bottom-0 text-xs text-red-600">{errors[name]}</p>}
        </div>
    );
}
